"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _deleteAccountVerify = _interopRequireDefault(require("./delete-account-verify.store"));
var _deleteAppleAccount = _interopRequireDefault(require("./delete-apple-account.store"));
var _deleteAccount = _interopRequireDefault(require("./delete-account.store"));
var _dec, _class;
/**
 * delete account store
 */
let DeleteAccountPageStore = (_dec = _mobx.action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function DeleteAccountPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, DeleteAccountPageStore);
    this.$env = void 0;
    this.deleteStore = void 0;
    this.deleteAccountVerifyStore = void 0;
    this.deleteAppleStore = void 0;
    this.$env = $env;
    this.deleteAccountVerifyStore = new _deleteAccountVerify.default(initialState.deleteAccountVerifyStore, $env);
    this.deleteStore = new _deleteAccount.default(initialState.deleteStore, $env);
    this.deleteAppleStore = new _deleteAppleAccount.default(initialState.deleteAppleStore, $env);
  }

  /**
   * reset API state to default
   */
  (0, _createClass2.default)(DeleteAccountPageStore, [{
    key: "reset",
    value: function reset() {
      this.deleteAccountVerifyStore.reset();
      this.deleteStore.reset();
    }
  }]);
  return DeleteAccountPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "reset", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype)), _class));
exports.default = DeleteAccountPageStore;